module.exports = __webpack_public_path__ + "assets/img/6915aaac84f38427e3253a87de59a103.svg";